/**
 *
 * ResultsDrTableHead
 *
 */

import React, { memo, FunctionComponent } from 'react';
import SortIndicatorComponent from '../../../../components/SortIndicator/SortIndicator.component';
import { Sort } from '../../../../domain';

interface IProps {
  changeSort: (field: string) => void;
  sort?: Sort;
  disabledFields: string[];
  desktopVisible: boolean;
  mobileVisible: boolean;
  tabletVisible: boolean;
  scoreByOptimumTime?: boolean;
}

const ResultsETTableHead: FunctionComponent<IProps> = ({
  sort,
  changeSort,
  disabledFields,
  scoreByOptimumTime,
}) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };

  return (
    <thead>
      <tr>
        <th scope="col">
          <SortIndicatorComponent
            field="eaEventClassAndSort"
            name="Class"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionName"
            name="Section"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" colSpan={3}>
          <SortIndicatorComponent
            field="bridleNumber"
            name="Rider/BN"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-hidden">
          <SortIndicatorComponent
            field="sjFaults"
            name="SJ Penalties"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-hidden">
          <SortIndicatorComponent
            field="xcFaults"
            name="XC Penalties"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-hidden">
          <SortIndicatorComponent
            field="totalJFaults"
            name="TotalJ Faults"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-hidden">
          <SortIndicatorComponent
            field="evTrialScoringTime"
            name="Time (secs)"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-hidden">
          <SortIndicatorComponent
            field="evTrialTimePenalties"
            name="Time (pens)"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-hidden">
          <SortIndicatorComponent
            field="evTrialTotalScore"
            name="Total Score"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" className="mobile-visible">
          {scoreByOptimumTime ? (
            <SortIndicatorComponent
              field=""
              name={`${isEnabled('totalJFaults') ? 'JF/' : ''}${isEnabled('evTrialTimePenalties') ? 'TF/' : ''}${isEnabled('evTrialTotalScore') ? 'S' : ''}`}
              sort={sort}
              changeSort={changeSort}
              disabledFields={disabledFields}
              tooltip={`${isEnabled('totalJFaults') ? 'Total Jumping Faults/' : ''}${isEnabled('evTrialTimePenalties') ? 'Time Penalties/' : ''}${isEnabled('evTrialTotalScore') ? 'Total Score' : ''}`}
            />
          ) : (
            <SortIndicatorComponent
              field=""
              name={`${isEnabled('sjFaults') ? 'SJp/' : ''}${isEnabled('xcFaults') ? 'XCp/' : ''}${isEnabled('evTrialScoringTime') ? 'T(s)/' : ''}${isEnabled('evTrialTotalScore') ? 'S' : ''}`}
              sort={sort}
              changeSort={changeSort}
              disabledFields={disabledFields}
              tooltip={`${isEnabled('sjFaults') ? 'SJ Penalties/' : ''}${isEnabled('xcFaults') ? 'XC Penalties/' : ''}${isEnabled('evTrialScoringTime') ? 'Time(seconds)/' : ''}${isEnabled('evTrialTotalScore') ? 'Total Score' : ''}`}
            />
          )}
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionPlace"
            name="SP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="overallPlace"
            name="OP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="riderClassStatusName"
            name="Status"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
      </tr>
    </thead>
  );
};

export default memo(ResultsETTableHead);
